import { render, staticRenderFns } from "./Hero1.vue?vue&type=template&id=1b89370c&scoped=true&"
import script from "./Hero1.vue?vue&type=script&lang=js&"
export * from "./Hero1.vue?vue&type=script&lang=js&"
import style0 from "./Hero1.vue?vue&type=style&index=0&id=1b89370c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b89370c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
